import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import {DummyDiv} from './styles'

const propTypes = {
  heightInPixel: PropTypes.string,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  heightInPixel: '24',
  backgroundColor: undefined,
}

export type SpacerProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const Spacer: React.FC<SpacerProps> = ({heightInPixel, backgroundColor}) => (
  <DummyDiv height={heightInPixel!} backgroundColor={backgroundColor} />
)

Spacer.propTypes = propTypes

Spacer.defaultProps = defaultProps

export default Spacer
